"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Link = require("./Link");

var _Link2 = _interopRequireDefault(_Link);

var _Markdown = require("./Markdown");

var _Markdown2 = _interopRequireDefault(_Markdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThingCommentEntry = function ThingCommentEntry(_ref) {
  var _ref$Link = _ref.Link,
      Link = _ref$Link === undefined ? _Link2.default : _ref$Link,
      _ref$Markdown = _ref.Markdown,
      Markdown = _ref$Markdown === undefined ? _Markdown2.default : _ref$Markdown,
      _ref$Timestamp = _ref.Timestamp,
      Timestamp = _ref$Timestamp === undefined ? function (_ref2) {
    var created_utc = _ref2.created_utc;
    return created_utc;
  } : _ref$Timestamp,
      collapsed = _ref.collapsed,
      name = _ref.name,
      author = _ref.author,
      subreddit = _ref.subreddit,
      _ref$siteprefix = _ref.siteprefix,
      siteprefix = _ref$siteprefix === undefined ? "r" : _ref$siteprefix,
      authorHref = _ref.authorHref,
      _ref$score = _ref.score,
      score = _ref$score === undefined ? null : _ref$score,
      downs = _ref.downs,
      score_hidden = _ref.score_hidden,
      likes = _ref.likes,
      isVoting = _ref.isVoting,
      ups = _ref.ups,
      scoreTooltip = _ref.scoreTooltip,
      body = _ref.body,
      body_html = _ref.body_html,
      permalink = _ref.permalink,
      banned_by = _ref.banned_by,
      meta_thing = _ref.meta_thing,
      stickied = _ref.stickied,
      distinguished = _ref.distinguished,
      controversiality = _ref.controversiality,
      created = _ref.created,
      created_utc = _ref.created_utc,
      link_author = _ref.link_author,
      link_author_href = _ref.link_author_href,
      link_title = _ref.link_title,
      link_permalink = _ref.link_permalink,
      _ref$showLink = _ref.showLink,
      showLink = _ref$showLink === undefined ? false : _ref$showLink,
      _ref$replyCount = _ref.replyCount,
      replyCount = _ref$replyCount === undefined ? null : _ref$replyCount,
      onReport = _ref.onReport,
      onGiveGold = _ref.onGiveGold,
      onSave = _ref.onSave,
      onToggleExpand = _ref.onToggleExpand,
      onVoteUp = _ref.onVoteUp,
      onVoteDown = _ref.onVoteDown,
      onShowReply = _ref.onShowReply;
  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      "p",
      { className: "parent" },
      _react2.default.createElement("a", { name: name }),
      showLink && link_permalink && link_title ? _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          Link,
          { href: link_permalink, className: "title" },
          link_title
        ),
        link_author ? _react2.default.createElement(
          _react.Fragment,
          null,
          "by ",
          _react2.default.createElement(
            Link,
            {
              href: link_author_href || "/user/" + link_author,
              className: "author may-blank"
            },
            link_author
          ),
          _react2.default.createElement("span", { className: "userattrs" })
        ) : null,
        subreddit ? _react2.default.createElement(
          _react.Fragment,
          null,
          "in ",
          _react2.default.createElement(
            Link,
            { className: "subreddit hover", href: "/" + siteprefix + "/" + subreddit },
            subreddit
          )
        ) : null
      ) : null
    ),
    onVoteUp || onVoteDown ? _react2.default.createElement(
      "div",
      { className: "midcol unvoted" },
      onVoteUp ? _react2.default.createElement("div", {
        "aria-label": "upvote",
        className: "arrow " + (likes === true ? "upmod" : "up") + " login-required access-required",
        "data-event-action": "upvote",
        role: "button",
        tabIndex: 0,
        onClick: onVoteUp
      }) : null,
      onVoteDown ? _react2.default.createElement("div", {
        "aria-label": "downvote",
        className: "arrow " + (likes === false ? "downmod" : "down") + " login-required access-required",
        "data-event-action": "downvote",
        role: "button",
        tabIndex: 0,
        onClick: onVoteDown
      }) : null
    ) : null,
    _react2.default.createElement(
      "div",
      { className: "entry unvoted" },
      _react2.default.createElement(
        "p",
        { className: "tagline" },
        onToggleExpand ? _react2.default.createElement(
          "a",
          {
            className: "expand",
            onClick: function onClick(e) {
              e.preventDefault();
              onToggleExpand();
            },
            href: ""
          },
          "[",
          collapsed ? "+" : "–",
          "]"
        ) : null,
        author ? _react2.default.createElement(
          Link,
          {
            className: "author may-blank id-t2_ " + (distinguished || ""),
            href: authorHref || "/user/" + author
          },
          author
        ) : null,
        distinguished && _react2.default.createElement(
          "span",
          { className: "userattrs" },
          "[",
          _react2.default.createElement(
            "a",
            { className: distinguished, title: distinguished, href: "/r/{subreddit}/about/moderators" },
            "M"
          ),
          "]",
          " "
        ),
        isVoting ? _react2.default.createElement(
          "span",
          { className: "loading working" },
          _react2.default.createElement("span", { className: "throbber" })
        ) : null,
        score_hidden ? _react2.default.createElement(
          "span",
          { className: "score-hidden", title: "scores are currently hidden for this comment" },
          "[score hidden]"
        ) : score !== null ? [_react2.default.createElement(
          "span",
          { className: "score dislikes", key: "dislikes", title: scoreTooltip },
          downs,
          " points"
        ), _react2.default.createElement(
          "span",
          { className: "score unvoted", key: "unvoted", title: scoreTooltip },
          score,
          " points"
        ), _react2.default.createElement(
          "span",
          { className: "score likes", key: "likes", title: scoreTooltip },
          ups,
          " points"
        )] : null,
        " ",
        _react2.default.createElement(Timestamp, { created: created, created_utc: created_utc }),
        "\xA0",
        stickied && _react2.default.createElement(
          "span",
          { className: "stickied-tagline", title: "stickied" },
          "stickied comment"
        ),
        replyCount !== null ? _react2.default.createElement(
          "a",
          { className: "numchildren" },
          replyCount,
          " children"
        ) : null
      ),
      _react2.default.createElement(
        "form",
        {
          action: "#",
          className: "usertext warn-on-unload"
        },
        _react2.default.createElement("input", { name: "thing_id", type: "hidden", defaultValue: "t1_h1" }),
        _react2.default.createElement(Markdown, { body: body, html: body_html, className: "usertext-body may-blank-within md-container" })
      ),
      _react2.default.createElement(
        "ul",
        { className: "flat-list buttons" },
        permalink ? _react2.default.createElement(
          "li",
          { className: "first" },
          _react2.default.createElement(
            Link,
            {
              className: "bylink",
              "data-event-action": "permalink",
              href: permalink,
              rel: "nofollow"
            },
            "permalink"
          )
        ) : null,
        onSave ? _react2.default.createElement(
          "li",
          { className: "comment-save-button save-button" },
          _react2.default.createElement(
            "a",
            { title: "save", onClick: onSave },
            "save"
          )
        ) : null,
        onReport ? _react2.default.createElement(
          "li",
          { className: "report-button" },
          _react2.default.createElement(
            "a",
            {
              className: "action-thing reportbtn access-required",
              "data-event-action": "report",
              onClick: onReport
            },
            "report"
          )
        ) : null,
        onGiveGold ? _react2.default.createElement(
          "li",
          { className: "give-gold-button" },
          _react2.default.createElement(
            "a",
            {
              className: "give-gold login-required access-required",
              "data-event-action": "gild",
              href: "/gold?goldtype=gift&months=1&thing=" + name,
              title: "give reddit gold in appreciation of this post.",
              onClick: onGiveGold
            },
            "give gold"
          )
        ) : null,
        onShowReply ? _react2.default.createElement(
          "li",
          { className: "reply-button" },
          _react2.default.createElement(
            "a",
            {
              className: "access-required",
              "data-event-action": "comment",
              href: permalink || "#",
              onClick: onShowReply
            },
            "reply"
          )
        ) : null,
        banned_by && _react2.default.createElement(
          "li",
          { title: "[removed]" },
          _react2.default.createElement(
            "b",
            null,
            "[removed by moderators]"
          )
        ),
        meta_thing && _react2.default.createElement(
          "li",
          null,
          _react2.default.createElement(
            Link,
            { href: meta_thing.data.permalink, title: meta_thing.data.score + " points" },
            meta_thing.data.num_comments,
            " comments on r/",
            meta_thing.data.subreddit
          )
        )
      ),
      _react2.default.createElement("div", { className: "reportform report-t1_h1" })
    )
  );
};

exports.default = ThingCommentEntry;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/ThingCommentEntry.js
// module id = 305
// module chunks = 0